import { Component, inject } from '@angular/core'
import { DatePipe } from '@angular/common'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'

import { Icon } from '@shared/ui'
import { Movement } from '../../models/tickets.model'

/**
 * La foto de un ticket rechazado, en grande. El tamaño de la imagen no se
 * conoce de antemano, así que se ajusta al alto de la pantalla.
 */
@Component({
  selector: 'ticket-image-modal',
  imports: [Icon, DatePipe],
  host: { class: 'card-panel block rounded-[20px] p-4' },
  template: `
    <header class="mb-3 flex items-start justify-between gap-3">
      <div>
        <h2 class="text-body text-gold-cream font-bold">Foto del ticket</h2>
        <p class="text-label text-blue-frost mt-1">{{ movement.date | date: 'd MMM y' }} · {{ movement.status }}</p>
      </div>

      <button
        type="button"
        aria-label="Cerrar"
        class="text-blue-sky shrink-0 transition-transform duration-100 ease-out active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100"
        (click)="dialogRef.close()">
        <icon
          name="circle-x"
          [size]="20" />
      </button>
    </header>

    <img
      class="border-blue-navy mx-auto max-h-[70dvh] w-auto max-w-full rounded-xl border object-contain"
      data-test="ticket-image"
      [src]="movement.image"
      alt="Foto del ticket rechazado" />
  `
})
export class TicketImageModal {
  protected readonly dialogRef = inject(DialogRef)
  protected readonly movement = inject<Movement>(DIALOG_DATA)
}
